import Seo from "../components/Seo";
import Section from "../components/ui-custom/Section";
import Pricing from "../components/sections/Pricing";
import FAQ from "../components/sections/FAQ";
import CTA from "../components/sections/CTA";
import PageHeader from "../components/ui-custom/PageHeader";

export default function PricingPage() {
  return (
    <>
      <Seo title="Pricing" description="Transparent utipanagecy pricing for Retailer, Distributor, Super Distributor and White Label plans." />
      <PageHeader eyebrow="Pricing" title="Simple, transparent pricing" sub="Coupon, activation and white-label pricing with the best margins in market." />
      <Section testId="pricing-page">
        <Pricing />
      </Section>
      <Section eyebrow="FAQ" heading="Pricing questions, answered" center testId="pricing-faq">
        <FAQ />
      </Section>
      <CTA />
    </>
  );
}
